import { getSanityImgUrl } from "@lib/sanity";
import { PageMetaFields, ProductMain } from "@sourceful/shared-types";

export const getProductOpenGraphImage = (product: ProductMain, pageMeta?: PageMetaFields) => {
  if (pageMeta?.openGraphImage) {
    return getSanityImgUrl(pageMeta.openGraphImage.asset._ref);
  }

  if (product.images && product.images.length > 0) {
    return getSanityImgUrl(product.images[0].asset._ref);
  }

  return undefined;
};
